import React from 'react'

import { Spinner } from '@plurall/elo-beta'

import styles from './Loading.module.scss'

const Loading = () => (
  <div className={styles.loading}>
    <Spinner size='large' dataTestId='loading-plurall-loading' />
  </div>
)

export default Loading
